import { render, staticRenderFns } from "./CreateQueryView.vue?vue&type=template&id=599a9a12&"
import script from "./CreateQueryView.vue?vue&type=script&lang=js&"
export * from "./CreateQueryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports